import { Meter } from '@/components/ui/progress'
import { LIMIT_LABELS, formatUsage, usageRatio, usageTone } from '@/lib/format'
import { cn } from '@/lib/utils'
import type { Entitlements, LimitKey } from '@/types/api'
import { PLAN_LIMIT_ORDER } from '../lib'

const TONE_TEXT = { ok: 'text-muted-foreground', warning: 'text-warning', critical: 'text-danger' } as const

export function UsageRow({ limitKey, used, limit, compact }: { limitKey: LimitKey; used: number; limit: number | null; compact?: boolean }) {
  const ratio = usageRatio(used, limit)
  const tone = usageTone(ratio)
  return (
    <div className={cn('grid gap-1.5', compact && 'gap-1')}>
      <div className="flex items-baseline justify-between gap-3 text-[13px]">
        <span className="font-medium">{LIMIT_LABELS[limitKey]}</span>
        <span className={cn('tabular text-xs', TONE_TEXT[tone])}>{formatUsage(limitKey, used, limit)}</span>
      </div>
      <Meter value={ratio} tone={tone === 'ok' ? 'brand' : tone} size={compact ? 'sm' : 'default'} label={`${LIMIT_LABELS[limitKey]} usage`} />
    </div>
  )
}

/** Usage meters for countable limits (skips upload size / retention which aren't consumed). */
export function UsageList({ entitlements, keys, compact }: { entitlements: Entitlements; keys?: LimitKey[]; compact?: boolean }) {
  const list = (keys ?? PLAN_LIMIT_ORDER.filter((k) => k !== 'upload_bytes' && k !== 'analytics_retention_days')).filter((k) => entitlements.limits[k])
  return (
    <div className={cn('grid', compact ? 'gap-3' : 'gap-4')}>
      {list.map((key) => {
        const entry = entitlements.limits[key]
        return <UsageRow key={key} limitKey={key} used={entry.used} limit={entry.limit} compact={compact} />
      })}
    </div>
  )
}
